import { Text } from '@/components/Text';
import { StyledHeadline } from '@/components/typography/components/Headline';
import styled from 'styled-components';

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

export const ContentContainer = styled.div`
  width: 25vw;
  min-width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${StyledHeadline} {
    margin-bottom: 32px;
  }

  ${Text} {
    margin: 0 auto 16px auto;
  }

  .ant-alert {
    width: 100%;
    margin: 0 auto 16px auto;
  }
`;

export const StyledAuthLayout = styled.div`
  min-width: 450px;
  padding: 24px;

  svg {
    width: 100%;
  }
`;
